module.exports = __webpack_public_path__ + "static/media/wheels-4.5165e628.png";